import React, {useContext} from 'react';
import {FormattedMessage} from "react-intl";

import SidebarItem from "../../../SidebarItem";

import {ReactComponent as HomeIcon} from "assets/img/home.svg";

import {Authorizations, hasAuthorization} from "utils/authorizations";
import {MarketplaceRoutes} from "utils/MarketplaceRoutes";

import {SidebarContext} from "../../../../../../SidebarContext";

function RetailerProfileItem(props) {
    const {currentPath, currentMemberAuthorizations, isUserAdmin} = useContext(SidebarContext);

    if (isUserAdmin || !hasAuthorization(currentMemberAuthorizations, Authorizations.OTHER_RETAILER_PROFILE)) {
        // If user is an admin (no retailer associated) he does not need to access retailers profile, he only needs retailer's full edit page.
        return null;
    }

    return (
        <SidebarItem
            isTopLevel
            icon={<HomeIcon />}
            to={MarketplaceRoutes.RETAILER_PROFILES}
            selected={currentPath.startsWith(MarketplaceRoutes.RETAILER_PROFILES)}
        >
            <FormattedMessage id={'sidebar.item.retailerProfiles'} />
        </SidebarItem>
    );
}

export default RetailerProfileItem;
